import { render } from "./CartItems.vue?vue&type=template&id=1c742326&ts=true"
import script from "./CartItems.vue?vue&type=script&lang=ts"
export * from "./CartItems.vue?vue&type=script&lang=ts"

import "./CartItems.vue?vue&type=style&index=0&id=1c742326&lang=scss"

import exportComponent from "C:\\Projects\\wordpress\\stadtwerke-bochum-gut-und-gruen-v2\\wp-content\\themes\\gut-und-gruen\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__